import { useMemo } from 'react';

import useMartyContext from 'hooks/useMartyContext';
import { getSelectedSortValue } from 'utils/getSelectedSortValue';
import type { SortOptionProps } from 'components/search/Sort';

export const useSortSelectedValue = (options: SortOptionProps[], selectedSort?: Record<string, string>): SortOptionProps | undefined => {
  const {
    marketplace: {
      search: { sortOptions }
    }
  } = useMartyContext();

  const selectedValue = useMemo(() => (selectedSort ? getSelectedSortValue(options, selectedSort) : sortOptions[0]), [options, selectedSort]);

  return selectedValue;
};
